import { createContext, useContext } from 'react'
import type { SubmitFeedback, UploadFeedbackAttachment } from '@/modules/feedback/use-cases'

export type FeedbackDialogContextValue = {
  isOpen: boolean
  openDialog: () => void
  closeDialog: () => void
  onSubmitFeedback: SubmitFeedback
  onUploadFeedbackAttachment: UploadFeedbackAttachment
  refreshToken: number
  notifySubmitted: () => void
}

export const FeedbackDialogContext = createContext<FeedbackDialogContextValue | null>(null)

export function useFeedbackDialogContext(): FeedbackDialogContextValue {
  const ctx = useContext(FeedbackDialogContext)
  if (!ctx) throw new Error('useFeedbackDialogContext must be used within FeedbackDialogProvider')
  return ctx
}
